import { createContext } from 'react'
import type { PluginContextValue } from './types'

export const PluginContext = createContext<PluginContextValue | null>(null)
